import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';
import { Spinner } from '@trello/nachos/spinner';

import { useUpdateWorkspaceMemberRole } from './useUpdateWorkspaceMemberRole';

import styles from './AdminRoleDemotionPopoverContent.less';

interface AdminRoleDemotionPopoverContentProps {
  hide: () => void;
  workspaceId: string;
  memberId: string;
}

export const AdminRoleDemotionPopoverContent: FunctionComponent<
  AdminRoleDemotionPopoverContentProps
> = ({ hide, workspaceId, memberId }) => {
  const { updateWorkspaceMemberRole, loading } = useUpdateWorkspaceMemberRole({
    memberId,
    workspaceId,
  });

  const handleClick = useCallback(() => {
    updateWorkspaceMemberRole({ memberType: 'normal', onSuccess: hide });
  }, [hide, updateWorkspaceMemberRole]);

  if (loading) {
    return <Spinner centered />;
  }
  return (
    <div>
      <p className={styles.description}>
        <FormattedMessage
          id="templates.workspace_member_roles.demote-admin-to-normal-member.text"
          defaultMessage="By becoming a normal member, you will lose all admin privileges such as the ability to change settings. To regain privileges, you will need another admin to change your role back to admin."
          description="Explains the consequences of demoting an admin to a normal member."
        />
      </p>
      <Button
        appearance="default"
        size="fullwidth"
        onClick={handleClick}
        className={styles.confirmationButton}
      >
        <FormattedMessage
          id="templates.workspace_member_roles.demote-admin-to-normal-member.confirm"
          defaultMessage="Make me a normal member"
          description="Confirms the user's decision to demote themselves from admin to normal member."
        />
      </Button>
    </div>
  );
};
